/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */

import { I18n } from '@bingads-webui-grid/well-known';
import React, { FC, Fragment, useRef, useState } from 'react';
import { anchorHrefPlaceholder } from '../utils';
import { ProductOffersCallout } from './ProductOffersCallout';
import { Model$Listing } from '../../ApiType';

/* eslint-disable react/jsx-filename-extension */
interface ConditionTemplateProps {
  total: any;
  depth: number;
  hasChildren: boolean;
  i18n: I18n;
  showSelectorIcon: boolean;
  attributeText: string;
  isExpanded: boolean;
  onToggleCollapse: () => void;
  onAddOrEditTrigger: () => void;
  partitionFullPath: Array<Model$Listing>;
  scope: {
    values: {
      campaignId: string | number;
    };
    save: Function;
  };
  productListingGroupId: number;
  assetGroupId: number | undefined;
}

const iconWidth = 12;

const levelGap = 10;

const textIconGap = 7;

export const ConditionTemplate: FC<ConditionTemplateProps> = (props) => {
  const {
    total, depth, hasChildren, i18n, showSelectorIcon,
    attributeText, isExpanded, onToggleCollapse, onAddOrEditTrigger,
    partitionFullPath, scope, productListingGroupId, assetGroupId,
  } = props;

  const updatedScope = {
    values: {
      ...scope.values,
      assetGroupId,
    },
    save: scope.save,
  };

  const attributeRef = useRef(null);
  const [showCallout, setShowCallout] = useState<boolean>(false);
  let hideCalloutTimer: number | undefined;
  const slowHideCallout = () => {
    hideCalloutTimer = window.setTimeout(() => {
      setShowCallout(false);
    }, 300);
  };

  const textPadding: React.CSSProperties = {
    paddingLeft: (hasChildren ? 0 : ((depth - 1) * levelGap) + iconWidth) + textIconGap,
  };

  const toggleIconMargin: React.CSSProperties = {
    marginLeft: (depth - 1) * levelGap,
    fontFamily: 'MsAds MDL2 Assets',
  };

  const onCollpaseToggleKeyDown: React.KeyboardEventHandler<HTMLSpanElement> = (e) => {
    if (e.key === 'Enter') {
      onToggleCollapse();
    }
    e.stopPropagation();
  };

  const onCollapseClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    onToggleCollapse();
    e.stopPropagation();
  };

  const onAddOrEditClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    onAddOrEditTrigger();
    e.stopPropagation();
  };

  const onAddOrEditKeyDown: React.KeyboardEventHandler<HTMLSpanElement> = (e) => {
    if (e.key === 'Enter') {
      onAddOrEditTrigger();
    }
    e.stopPropagation();
  };
  const closeTooltip: React.KeyboardEventHandler<HTMLSpanElement> = (e) => {
    if (e.key === 'Escape') {
      setShowCallout(false);
    }
    e.stopPropagation();
  };
  return (
    <Fragment>
      {total ? <div>{total}</div> :
        <div className="grid-cell listing-group-condition-cell tree-view-cell">
          {hasChildren &&
            (isExpanded ?
              <span style={toggleIconMargin} onClick={onCollapseClick} onKeyDown={onCollpaseToggleKeyDown} tabIndex={0} role="button" className="small-icon iconba expand-button iconba-CaretSolidDown" aria-label={i18n.getString(_TL_('Expand'))} />
              : <span style={toggleIconMargin} onClick={onCollapseClick} onKeyDown={onCollpaseToggleKeyDown} tabIndex={0} role="button" className="small-icon iconba expand-button iconba-CaretSolidRight" aria-label={i18n.getString(_TL_('Collapse'))} />)
          }
          <div style={textPadding}>
            <div className="attributeContainer" onMouseEnter={() => clearTimeout(hideCalloutTimer)} onMouseLeave={() => slowHideCallout()}>
              {
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                <a ref={attributeRef} onMouseOver={() => setShowCallout(true)} onFocus={() => setShowCallout(true)} onKeyDown={e => closeTooltip(e)} onBlur={() => setShowCallout(false)} href={anchorHrefPlaceholder} className="listing-group-name-container" aria-label={attributeText}>
                  {attributeText}
                </a>
              }
              { showCallout && <ProductOffersCallout target={attributeRef} i18n={i18n} fullPath={partitionFullPath} scope={updatedScope} productListingGroupId={productListingGroupId} /> }
            </div>
            <div className="listing-group-icon-container">
              {showSelectorIcon &&
                <span
                  className={`listing-group-row-icon clickable show-listing-group-selector iconba  ${hasChildren ? 'iconba-Edit' : 'iconba-CalculatorAddition'}`}
                  tabIndex={0}
                  role="button"
                  onClick={onAddOrEditClick}
                  onKeyDown={onAddOrEditKeyDown}
                  aria-label={hasChildren ? i18n.getString(_TL_('Edit')) : i18n.getString(_TL_('Add'))}
                />
              }
            </div>
          </div>
        </div>
      }
    </Fragment>);
};
